/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { DialogActions, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";

const ImageEditDialogTopActions = () => {
    const { t }  = useTranslation();
    const imageEditContext = useContext(ImageEditContext);
    const selectedEditTab = imageEditContext?.selectedEditTab;
    const setSelectedEditTab = imageEditContext?.setSelectedEditTab;

    const handleTabsChange = (event, newValue) => {
        switch (newValue) {
            case 0:
                setSelectedEditTab(newValue);
                break;
            case 1:
                setSelectedEditTab(newValue);
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <DialogActions
                className="simplicity-image-selector-window-tabs edit-image-window-tabs"
                style={{  }}
            >
                <Tabs value={selectedEditTab} onChange={handleTabsChange} aria-label="edit tabs">
                    <Tab label={t("commons.details")} id='tabpanel-1' aria-controls='tabpanel-1' />
                    <Tab label={t("commons.placements")} id='tabpanel-2' aria-controls='tabpanel-2' />
                </Tabs>
            </DialogActions>
        </Fragment>
    );
};

export { ImageEditDialogTopActions };
